export default function Profile() {
    // TODO: Implement this function
    return <h1>Profile</h1>
}